module.exports = __webpack_public_path__ + "img/iconTuiTongJiLu.4818921d.svg";